import { render } from "./ThanksBlock.vue?vue&type=template&id=6e1fc2d5&scoped=true"
import script from "./ThanksBlock.vue?vue&type=script&lang=js"
export * from "./ThanksBlock.vue?vue&type=script&lang=js"

import "./ThanksBlock.vue?vue&type=style&index=0&id=6e1fc2d5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e1fc2d5"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
